import { keyValueList } from "../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { ofArray, empty, singleton, append } from "../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { Account_ChangePassword, Account_OtpConfirmation, Account_ChangePassword_$reflection, Account_OtpConfirmation_$reflection, Account_OtpActivation_$reflection, Account_UserInfo_$reflection } from "../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { sendJson, postEmpty, errorString, Encoders } from "../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../fable_modules/fable-library-js.4.19.0/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/./Encode.fs.js";
import { Loaded, errorCmd, request, postEmpty as postEmpty_1 } from "../../../Bfs.Web.Portale/Http.fs.js";
import { Model, PasswordModel_Init_6DFDD678, PasswordMsg, PasswordModel, OtpStatus, OtpMsg, OtpModel, Msg, Model_InitPassword_Z721C83C5 } from "./Types.fs.js";
import { value as value_3, map, defaultArg } from "../../fable_modules/fable-library-js.4.19.0/Option.js";
import { update } from "../../../Bfs.Web.Portale/Validation.fs.js";
import { Cmd_map, Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";

export function Http_userDetails() {
    const response = fetch("/api/account/details", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Account_UserInfo_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_activateOtp() {
    const response = postEmpty("/api/account/activateotp");
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Account_OtpActivation_$reflection(), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_confirmOtp(data) {
    return sendJson("/api/account/confirmotp", toString(0, Auto_generateBoxedEncoder_437914C6(Account_OtpConfirmation_$reflection(), undefined, undefined, undefined)(data)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
}

export function Http_deactivateOtp() {
    return postEmpty_1("/api/account/deactivateOtp");
}

export function Http_updatePassword(data) {
    const response = sendJson("/api/account/password", toString(0, Auto_generateBoxedEncoder_437914C6(Account_ChangePassword_$reflection(), undefined, undefined, undefined)(data)), singleton(new Types_RequestProperties(4, ["include"])), "POST");
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            return response_1_1.text();
        }
    });
}

export function State_init(page, user, lastModel) {
    return [Model_InitPassword_Z721C83C5(defaultArg(map((u) => u.Name, user), "")), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_updateOtp(msg, model) {
    switch (msg.tag) {
        case 1:
            return [new OtpModel(model.Status, update(model.OtpField, msg.fields[0]), model.ErrorMsg, model.Secret, model.QrCode), Cmd_none(), Cmd_none()];
        case 2:
            return [model, request(Http_activateOtp, undefined, (Item) => (new OtpMsg(3, [Item]))), Cmd_none()];
        case 3:
            if (msg.fields[0].tag === 1) {
                return [model, Cmd_none(), errorCmd((Item_1) => (new Msg(4, [Item_1])), "Aktivieren", msg.fields[0].fields[0])];
            }
            else {
                return [new OtpModel(new OtpStatus(1, []), model.OtpField, undefined, msg.fields[0].fields[0].Secret, msg.fields[0].fields[0].QrDataUrl), Cmd_none(), Cmd_none()];
            }
        case 4:
            return [model, request(Http_confirmOtp, new Account_OtpConfirmation(model.Secret, model.OtpField.Value), (Item_2) => (new OtpMsg(5, [Item_2]))), Cmd_none()];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [new OtpModel(model.Status, model.OtpField, "Das Einmalpasswort ist falsch.", model.Secret, model.QrCode), Cmd_none(), Cmd_none()];
            }
            else {
                return [model, Cmd_none(), singleton((dispatch) => {
                    dispatch(new Msg(0, []));
                })];
            }
        case 6:
            return [model, request(Http_deactivateOtp, undefined, (Item_3) => (new OtpMsg(7, [Item_3]))), Cmd_none()];
        case 7:
            if (msg.fields[0].tag === 1) {
                return [model, Cmd_none(), errorCmd((Item_4) => (new Msg(4, [Item_4])), "Deaktivieren", msg.fields[0].fields[0])];
            }
            else {
                return [model, Cmd_none(), singleton((dispatch_1) => {
                    dispatch_1(new Msg(0, []));
                })];
            }
        default:
            return [new OtpModel(new OtpStatus(2, [msg.fields[0]]), model.OtpField, model.ErrorMsg, model.Secret, model.QrCode), Cmd_none(), Cmd_none()];
    }
}

export function State_updatePassword(msg, model) {
    switch (msg.tag) {
        case 1:
            return [new PasswordModel(model.OldPassword, update(model.NewPassword1, msg.fields[0]), model.NewPassword2, model.ErrorMsg, model.OkMsg), Cmd_none()];
        case 2:
            return [new PasswordModel(model.OldPassword, model.NewPassword1, update(model.NewPassword2, msg.fields[0]), model.ErrorMsg, model.OkMsg), Cmd_none()];
        case 3:
            return [model, request(Http_updatePassword, new Account_ChangePassword(model.OldPassword.Value, model.NewPassword1.Value, model.NewPassword2.Value), (Item) => (new PasswordMsg(4, [Item])))];
        case 4:
            if (msg.fields[0].tag === 1) {
                return [new PasswordModel(model.OldPassword, model.NewPassword1, model.NewPassword2, msg.fields[0].fields[0].message, model.OkMsg), Cmd_none()];
            }
            else if (msg.fields[0].fields[0] === "") {
                return [PasswordModel_Init_6DFDD678("Ihr Passwort wurde geändert!"), Cmd_none()];
            }
            else {
                return [new PasswordModel(model.OldPassword, model.NewPassword1, model.NewPassword2, msg.fields[0].fields[0], model.OkMsg), Cmd_none()];
            }
        default:
            return [new PasswordModel(update(model.OldPassword, msg.fields[0]), model.NewPassword1, model.NewPassword2, model.ErrorMsg, model.OkMsg), Cmd_none()];
    }
}

export function State_update(msg, model) {
    let matchResult, x, otpmsg_1, pwmsg_1;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            x = msg.fields[0];
            break;
        }
        case 2: {
            if (model.Otp != null) {
                matchResult = 2;
                otpmsg_1 = msg.fields[0];
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 3: {
            if (model.Password != null) {
                matchResult = 3;
                pwmsg_1 = msg.fields[0];
            }
            else {
                matchResult = 5;
            }
            break;
        }
        case 4: {
            matchResult = 4;
            break;
        }
        default:
            matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return [model, request(Http_userDetails, undefined, (Item) => (new Msg(1, [Item])))];
        case 1: {
            const status = (x.tag === 0) ? (x.fields[0].OtpEnabeld ? (new OtpStatus(2, [false])) : (new OtpStatus(0, []))) : (new OtpStatus(0, []));
            const otpModel = map((o) => (new OtpModel(status, o.OtpField, o.ErrorMsg, o.Secret, o.QrCode)), model.Otp);
            return [new Model(model.Name, Loaded(x), otpModel, model.Password), Cmd_none()];
        }
        case 2: {
            const patternInput = State_updateOtp(otpmsg_1, value_3(model.Otp));
            return [new Model(model.Name, model.UserInfo, patternInput[0], model.Password), Cmd_batch(ofArray([Cmd_map((Item_1) => (new Msg(2, [Item_1])), patternInput[1]), patternInput[2]]))];
        }
        case 3: {
            const patternInput_1 = State_updatePassword(pwmsg_1, value_3(model.Password));
            return [new Model(model.Name, model.UserInfo, model.Otp, patternInput_1[0]), Cmd_map((Item_2) => (new Msg(3, [Item_2])), patternInput_1[1])];
        }
        case 4:
            return [model, Cmd_none()];
        default:
            return [model, Cmd_none()];
    }
}

//# sourceMappingURL=State.fs.js.map
